"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userModel = void 0;
var userModel = {
  id: {
    type: Number,
    field: 'Id',
    path: 'Id[0]'
  },
  loginName: {
    type: String,
    field: 'LoginName',
    path: 'LoginName[0]'
  },
  fullName: {
    type: String,
    field: 'FullName',
    path: 'FullName[0]'
  },
  password: {
    type: String,
    field: 'Password',
    path: 'Password[0]' // isLocked: {type: Boolean, field: 'IsLocked', path: 'IsLocked[0]'},
    // expireDate: {type: DataServerDate, field: 'ExpireDate', path: 'ExpireDate[0]'},
    // lastLogin: {type: DataServerDate, field: 'LastLogin', path: 'LastLogin[0]'},
    // authType: {type: String, field: 'AuthType', path: 'AuthType[0]'},
    // externalLoginName: {type: String, field: 'ExternalLoginName', path: 'ExternalLoginName[0]'}

  }
};
exports.userModel = userModel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/users/models/user.js
// module id = 222
// module chunks = 0